import * as React from 'react';
import { styled } from '@glitz/react';
import { MapPinIcon } from 'svenssons/shared/icons';
import { monochromeDark } from 'svenssons/shared/theme';
import { getLocalStorageItem, translate, useDynamicData } from '@avensia/excite';
import { STORE_LOCALSTORAGE_KEY } from './StoreAvailabilityFlyout';
import { getStoreAvailabilityTranslation } from './StoreAvailability';
import { ResetButton } from 'webapp/components/button/button';

type PropType = {
  showStoreAvailability?: () => void;
  storesAvailability: NordicNest.Api.StoreAvailabilityApiModel[];
};

export const StoreInfo = ({ showStoreAvailability, storesAvailability }: PropType) => {
  const selectedStoreId = getLocalStorageItem<string>(STORE_LOCALSTORAGE_KEY);
  const [storesData] = useDynamicData<NordicNest.Api.StoresApiModel>();
  if (!storesData?.stores) {
    return null;
  }
  const selectedStore = storesData?.stores?.find(store => store.id === selectedStoreId);

  return (
    <Container>
      <MapPinIcon />
      <Store>
        <Text>{selectedStore?.name ?? translate(t => t.productPage.uspClickAndCollect)}</Text>
        {selectedStore && (
          <StockStatus>
            {getStoreAvailabilityTranslation(
              storesAvailability?.find(s => s.storeId === selectedStoreId)?.storeAvailability,
            )}
          </StockStatus>
        )}
      </Store>
      <ShowMoreButton onClick={showStoreAvailability}>
        {selectedStore ? translate(t => t.productPage.changeStore) : translate(t => t.productPage.selectStore)}
      </ShowMoreButton>
    </Container>
  );
};

const Container = styled.div({
  display: 'grid',
  gridTemplateColumns: '24px auto auto',
  gridGap: t => t.sharedSpacing.m,
  alignItems: 'center',
  padding: { xy: t => t.sharedSpacing.m },
  border: { xy: { style: 'solid', color: monochromeDark, width: 1 }, top: { style: 'none' } },
});

const Store = styled.div();

const Text = styled.span({
  fontSize: t => t.sharedFontSize.xs,
});

const StockStatus = styled.div({
  fontSize: t => t.sharedFontSize.xs,
  fontWeight: 400,
});

const ShowMoreButton = styled(ResetButton, {
  fontSize: t => t.sharedFontSize.xs,
  textDecoration: 'underline',
  justifySelf: 'end',
});
